'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BLACK: '#4d4d4f',
  DARK_GREY: '#79797b',
  GREY: '#a8a8aa',
  LIGHT_GREY: '#d9d9dc',
  WHITE: '#ffffff',
  PRIMARY: '#26a0da',

  PADDING: 8
};